<template>
  <v-data-table
    item-key="id"
    loading-text="Đang Tải"
    :server-items-length="totalCount"
    :headers="headers"
    :items="items"
    :loading="loading"
    disable-sort
    @update:page="val => updatePagination('page', val)"
    @update:items-per-page="val => updatePagination('itemsPerPage', val)"
  >
    <template v-slot:[`item.title`]="{ item }">
      <router-link style="text-decoration: none" :to="'/survey-detail/' + item.id">
        {{ item.title }}
      </router-link>
    </template>
    <template v-slot:[`item.createdBy`]="{ item }">
      {{ get(item, 'createdBy.name', '') }}
    </template>
    <template v-slot:[`item.createdAt`]="{ item }">
      {{ item.createdAt | ddmmyyyy }}
    </template>
    <template v-slot:[`item.deadline`]="{ item }">
      {{ item.deadline | ddmmyyyy }}
    </template>
    <template v-slot:[`item.status`]="{ item }">
      <v-chip small label :color="item.status | getColorStatusSurvey" dark>
        <span v-if="item.status">
          {{ item.status | getTextStatusSurvey }}
        </span>
      </v-chip>
    </template>
    <template v-slot:[`item.isExpired`]="{ item }">
      <v-chip small label :color="item.isExpired | surveyExpireColor" dark>
        {{ item.isExpired | surveyIsExpiredText }}
      </v-chip>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-btn icon @click="() => $router.push('/survey-detail/' + item.id)">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { get } from 'lodash'
import { headers } from '../survey/SurveyTable/helper'
export default {
  name: 'SurveyTable',
  data: () => ({ headers }),
  computed: {
    ...mapState({
      items: state => state.survey.items,
      totalCount: state => state.survey.totalCount,
      loading: state => state.survey.loading
    })
  },
  methods: {
    ...mapActions({
      fetch: 'survey/fetch',
      count: 'survey/count'
    }),
    get,
    async updatePagination(type, val) {
      const page = type === 'page' ? val : 1
      const itemsPerPage = type === 'itemsPerPage' ? val : 10
      await this.fetch({
        _start: type === 'itemsPerPage' ? 0 : (page - 1) * itemsPerPage,
        _limit: itemsPerPage,
        ...this.query
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
